/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('LinkBuilder', ['DateTools', 'LinkConfiguration', function (DateTools, LinkConfiguration) {
        function LinkBuilder(link) {
            this.link = link;
        }

        LinkBuilder.prototype = {
            buildFromLink: function () {
                _addNeverExpire(this.link);
                _addEmailFields(this.link);
                _addConfigurationRestrictions(this.link);
                _addMethods(this.link);

                if (this.link.hasExpirationDate()) {
                    this.link.days_until_expiration = this.link.ttl - DateTools.daysSince(this.link['created_at']);
                }

                this.link.isShared = this.link.getRecipientsCount() > 0;
                this.link.hasPassword = this.link.isPublicWithPassword();
            },

            buildGetLinkFromFile: function (node) {
                this.link.isShared = false;

                _addCommonForNew(this.link, node);
                _addConfigurationRestrictions(this.link);
                _addMethods(this.link);

                this.link.permissions.canSetLinkType = LinkConfiguration.canSetLinkTypeOnGetLink;
                return this.link;
            },

            buildEmailLinkFromFile: function (node) {
                this.link.node = node;

                _addCommonForNew(this.link, node);
                _addEmailFields(this.link);
                _addConfigurationRestrictions(this.link);
                _addMethods(this.link);

                return this.link;
            }
        };

        function _addNeverExpire(link) {
            link.never_expire = !link.ttl;
        }

        function _addCommonForNew(link, node) {
            link.ttl = LinkConfiguration.getTtl();
            link.note = LinkConfiguration.getNote();
            link.node_uuid = node.uuid;
            link.never_expire = false;
            link.esignature_uuid = node.esignature_uuid;
            link.single_use = LinkConfiguration.isSingleUseOnlyRequired();
            link.access_restriction = LinkConfiguration.getAccessRestrictionType();
            link.allow_guest_downloads = true;
            link.hasPassword = false;
        }

        function _addEmailFields(link) {
            link.message = '';
            link.isShared = true;

            link.setLanguage = function (lang) {
                link.locale = lang.id;
                link.language = lang.value;
            };
        }

        function _addConfigurationRestrictions(link) {
            link.permissions = LinkConfiguration.getPermissions();
        }

        function _addMethods(link) {
            var expirationDate = null,
                originalDownloadCount = link['download_count'];

            if (link['ttl']) {
                expirationDate = DateTools.addDays(link['created_at'], link['ttl']);
            }

            link.getRecipientsCount = function () {
                return link.recipients.length;
            };

            link.getGroupsCount = function () {
                return link.recipients.filter(({ type }) => type === 'group').length;
            };

            link.getEmailsCount = function () {
                return link.recipients.filter(({ type }) => type === 'email').length;
            };

            link.isEditable = function () {
                return !link.isExpired() && link.isAvailable();
            };

            link.getRevokedDate = function () {
                return DateTools.formatDate(link['deleted_at'], true);
            };

            link.isDisabledByPolicy = function () {
                return false;
            };

            link.isExpired = function () {
                return expirationDate && expirationDate < DateTools.dateNow();
            };

            link.getExpirationDate = function () {
                return DateTools.addDays(link['created_at'], link['ttl']);
            };

            link.getDaysUntilExpiration = function () {
                return link['ttl'] - DateTools.daysSince(link['created_at']);
            };

            link.getExpirationDateFormatted = function () {
                return DateTools.formatDate(expirationDate, false);
            };

            link.hasReachedMaxDownloadCount = function () {
                return link['single_use'] && link['download_count'] >= 1;
            };

            link.getSharedDate = function () {
                return DateTools.formatDate(link['created_at'], true);
            };

            link.hasExpirationDate = function () {
                return !!link['ttl'];
            };

            link.isAvailable = function () {
                return !link['deleted_at'] && !link.hasReachedMaxDownloadCount();
            };

            link.onSingleUseChanged = function () {
                link['download_count'] = link['single_use'] ? 0 : originalDownloadCount;
            };

            link.isEsignature = function () {
                return angular.isDefined(link.esignature_uuid) || link.esignature;
            };

            link.isPublic = function () {
                return link.access_restriction === 'public';
            }

            link.isPublicWithPassword = function () {
                return link.access_restriction === 'public_with_password';
            }
        }

        return function (link) { return new LinkBuilder(link) };
    }]);
